/**
 * [#8] Dropdowns & UX — shared option lists so common free-text fields become
 * pick-or-type dropdowns instead of blank inputs. These reduce manual input and
 * keep values consistent across the marketplace, while still allowing a custom
 * entry (SmartSelect allowOther / <datalist> both keep free typing).
 */

/** Common marketplace / construction units (PH context). Pick-or-type. */
export const COMMON_UNITS: string[] = [
  "pc", "pcs", "set", "unit", "lot", "pair", "dozen", "pack", "bundle",
  "bag", "sack", "box", "carton", "roll", "sheet", "ream", "drum", "can", "tube",
  "kg", "g", "ton", "L", "mL", "gal",
  "m", "cm", "ft", "sqm", "cu.m", "board ft",
  "truckload", "trip", "hour", "day", "week", "month",
];
